import React from 'react';
import { NetworkInsights } from '@frontend/gql/social/graphql';
import { Card } from '@frontend/shadcn/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@frontend/shadcn/components/ui/table';
import { PinterestIcon } from '@revfluence/fresh-icons/brands/esm';
import {
  TableHeader as TableHeaderComponent,
  TableHeaderSection,
  TableHeaderLayout,
  TableHeaderLabel,
} from '../table-header';

interface PinterestMetricsCardProps {
  data?: NetworkInsights | null;
}

export const PinterestMetricsCard = ({ data }: PinterestMetricsCardProps) => {
  return (
    <Card aria-label="Pinterest Metrics">
      <TableHeaderComponent>
        <TableHeaderLayout>
          <TableHeaderSection>
            <TableHeaderLabel>
              <div className="flex items-center gap-2">
                <PinterestIcon className="h-5 w-5 text-[#E60023]" />
                <span aria-live="polite">Pinterest</span>
              </div>
            </TableHeaderLabel>
          </TableHeaderSection>
        </TableHeaderLayout>
      </TableHeaderComponent>
      <Table
        className="[&_th]:border-r [&_th]:border-b [&_th]:border-t [&_td]:border-r [&_td]:border-b [&_td]:border-t [&_tr:last-child_td]:border-b"
        wrapperProps={{ className: 'h-auto' }}
      >
        <TableHeader>
          <TableRow>
            <TableHead className="text-left px-4 py-2">Metric</TableHead>
            <TableHead className="text-right px-4 py-2">Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className="text-left"># of Posts</TableCell>
            <TableCell className="text-right">{data?.postsCreated?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left">Potential Reach</TableCell>
            <TableCell className="text-right">{data?.reach?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left">Impression</TableCell>
            <TableCell className="text-right">{data?.impressions?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left">Engagement</TableCell>
            <TableCell className="text-right">{data?.engagements?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left">Eng Rate</TableCell>
            <TableCell className="text-right">{data?.engagementRate ? `${(data.engagementRate * 100).toFixed(2)}%` : '0%'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};
